<app-stages [stages]="stages" currentStage="Zażalenie"></app-stages>
<br>
@if (!pending() && !loading()) {
  <form autocomplete="off" novalidate [formGroup]="form" (ngSubmit)='submitAndGoNext()'>
    <div class="row">
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"decisionDate" as controlName'>
          <label [for]='controlName'>
            Data wydania postanowienia *
          </label>
          <app-date-picker
            [id]='controlName'
            [formControlName]='controlName'>
          </app-date-picker>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"decisionDeliveryDate" as controlName'>
          <label [for]='controlName'>
            Data otrzymania postanowienia *
          </label>
          <app-date-picker
            [id]='controlName'
            [formControlName]='controlName'>
          </app-date-picker>
          <app-validation-errors
            fieldLabel='Data otrzymania'
            secondFieldLabel='dacie wydania'
            [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"appealSubject" as controlName'>
          <label [for]='controlName'>
            Zaskarżenie dotyczy *
          </label>
          <select
            (change)="form.appealSubjectChange(form.getElement($event).value)"
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'>
            <option value=''>Wybierz</option>
            <option [value]='item' *ngFor='let item of form.appealSubjects'>
              {{ item }}
            </option>
          </select>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      @if (form.appealSubjectDescription) {
        <div class='col-md-12'>
          <div class='form-group' *ngIf='"appealSubjectDescription" as controlName'>
            <label [for]='controlName'>
              Zaskarżenie dotyczy części *
            </label>
            <textarea
              rows="4"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu część której dotyczy zaskarżenie'>
          </textarea>
            <app-validation-errors
              [showTextLength]="true"
              [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
    </div>
    <fieldset>
      <legend>
        Powód zaskarżenia
      </legend>
      <div class="row">
        <div class='col-md-12'>
          <app-alert type="info" alertTittle="Uwaga!" [closable]="false">
            Wymagane wypełnienia min. 1 pola opisowego.
          </app-alert>
          <div class='form-group' *ngIf='"appealGroundLegalBreach" as controlName'>
            <label [for]='controlName'>
              Naruszenie przepisów prawa procesowego @if (form.hasRequiredValidator(form.appealGroundLegalBreach)) {
              *
            }
            </label>
            <textarea
              rows="4"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu na czym polega naruszenie przepisów (jeśli dotyczy)'>
          </textarea>
            <app-validation-errors
              [showTextLength]="true"
              [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
          <div class='form-group' *ngIf='"appealGroundNewFacts" as controlName'>
            <label [for]='controlName'>
              Nowe okoliczności faktyczne @if (form.hasRequiredValidator(form.appealGroundNewFacts)) {
              *
            }
            </label>
            <textarea
              rows="4"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu nowe okoliczności (jeśli dotyczy)'>
            </textarea>
            <app-validation-errors
              [showTextLength]="true"
              [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    </fieldset>
    <div class="row">
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"appealRequest" as controlName'>
          <label [for]='controlName'>
            Wnoszę o *
          </label>
          <select
            (change)="form.appealRequestChange(form.getElement($event).value)"
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'>
            <option value=''>Wybierz</option>
            <option [value]='item' *ngFor='let item of form.appealRequests'>
              {{ item }}
            </option>
          </select>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      @if (form.appealRequestDescription) {
        <div class='col-md-12'>
          <div class='form-group' *ngIf='"appealRequestDescription" as controlName'>
            <label [for]='controlName'>
              Opis zmiany *
            </label>
            <textarea
              rows="4"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu opis'>
          </textarea>
            <app-validation-errors
              [showTextLength]="true"
              [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
    </div>
    <div class='application-actions'>
      <button
        type='button'
        class='btn btn-secondary'
        (click)='onCancel()'>
          <span>
            Wstecz
          </span>
      </button>
      <button
        type='submit'
        class='btn btn-primary'>
        <span>Zapisz i przejdź dalej</span>
      </button>
    </div>
  </form>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
